export default __webpack_public_path__ + "static/media/Slayer's Mantle of the Living Legend.e4d12532.jpg";